import { Helmet } from "react-helmet";
import AirportTransferHero from "./airport_transfer/airport_transfer-hero";
import AirportTransferLanding from "./airport_transfer/airport_transfer-landing";

export default function AirportTransfer() {
    return (
        <>
            <Helmet>
                <title>Airport Transfers in Hyderabad | PVR CABS</title>
                <meta name="description" content="On-time airport pickup and drop services in Hyderabad with clean, professional vehicles. Book 24/7 with PVR CABS." />
                <link rel="canonical" href="https://pvrcabs.com/airport-transfer" />
            </Helmet>

            <div>
                <AirportTransferHero />
                <AirportTransferLanding />
            </div>
        </>
    )
}